import { Tooltip } from '@pique/component';
import { useI18n } from '@pique/i18n';

import { ellipsisTextStyle } from './index.css';
type FilterTagProps = {
  name: string;
};

const useFilterTag = ({ name }: FilterTagProps) => {
  const t = useI18n();
  switch (name) {
    case 'Created':
      return t['Created']();
    case 'Updated':
      return t['Updated']();
    case 'Tags':
      return t['Tags']();
    case 'Attendees':
      return 'Attendees';
    case 'Title':
      return 'Meeting';
    case 'Is Favourited':
      return t['com.pique.filter.is-favourited']();
    case 'Is Public':
      return t['com.pique.filter.is-public']();
    case 'after':
      return t['com.pique.filter.after']();
    case 'before':
      return t['com.pique.filter.before']();
    case 'last':
      return t['com.pique.filter.last']();
    case 'is':
      return t['com.pique.filter.is']();
    case 'is not empty':
      return t['com.pique.filter.is not empty']();
    case 'is empty':
      return t['com.pique.filter.is empty']();
    case 'contains all':
      return t['com.pique.filter.contains all']();
    case 'contains one of':
      return t['com.pique.filter.contains one of']();
    case 'does not contains all':
      return t['com.pique.filter.does not contains all']();
    case 'does not contains one of':
      return t['com.pique.filter.does not contains one of']();
    case 'true':
      return t['com.pique.filter.true']();
    case 'false':
      return t['com.pique.filter.false']();
    default:
      return name;
  }
};

export const FilterTag = ({ name }: FilterTagProps) => {
  const tag = useFilterTag({ name });

  return (
    <Tooltip content={tag}>
      <span className={ellipsisTextStyle} data-testid={`filler-tag-${tag}`}>
        {tag}
      </span>
    </Tooltip>
  );
};
